import http from '@/plugins/axios/axios';

export default class RevendedorService {

    salvar(requisicao) {       
        return http.post('/api/adm/revendedor/salvar', requisicao);
    } 

    excluir(requisicao) {       
        return http.post('/api/adm/revendedor/excluir', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/adm/revendedor/listar', requisicao);
    } 

    listarTodos(requisicao) {       
        return http.post('/api/adm/revendedor/listar-todos', requisicao);
    } 

    listarClientes(requisicao) {       
        return http.post('/api/adm/revendedor/listar-clientes', requisicao);
    } 
}